import React from 'react'
import { SanityNewsletterForm } from '../../../../../types/generated/graphql-types'
import { mapSanityNewsletterFormToNewsletterFormProps } from '../../../../mapping/NewsletterFormMapper'
import { NewsletterForm } from '../../../NewsletterForm/NewsletterForm'

export const NewsletterFormSerializer = ({ ...props }: SanityNewsletterForm) => (
  <NewsletterForm {...mapSanityNewsletterFormToNewsletterFormProps(props)} />
)
